import {
  backend_url,
  uninterceptedAxiosInstance,
  qs,
} from "../common/commonVariables";

export const getAllVendros = async (
  organisationID = "",
  searchName = "",
  page = 1,
  pageSize = 99999,
  location = [],
  startDate = [],
  endDate = [],
  sort = [],
  role,
  allIds
) => {
  let assetFilters = {
    organisation: {
      id: {
        $eq: organisationID,
      },
    },
   
  };

  if (startDate.length === 1) {
    assetFilters.startDate = {
      $gte: startDate[0],
    };
  } else if (startDate.length === 2) {
    assetFilters.startDate = {
      $gte: startDate[0],
      $lte: startDate[1],
    };
  }

  if (endDate.length === 1) {
    assetFilters.endDate = {
      $gte: endDate[0],
    };
  } else if (endDate.length === 2) {
    assetFilters.endDate = {
      $gte: endDate[0],
      $lte: endDate[1],
    };
  }

  if (location?.length == 0 && role !== "super_admin") {
    assetFilters.location = {
      id: {
        $in: allIds,
      },
    };
  } else {
    assetFilters.location = {
      id: {
        $in: location,
      },
    };
  }

  const queryParams = {
    sort: sort.length > 0 ? sort : ["countNumId:desc"],
    filters: assetFilters,
    _q: searchName,
    populate: [
      "customFields",
      "billingInformation",
      "billingInformation.paymentDetails",
      "contactInformation",
      "logo",
      "parts",
      "assets",
      "createdByUser",
      "updatedByUser",
      "location",
      "createdByUser.profileImage",
    ],
  };

  if (page && pageSize) {
    queryParams["pagination[page]"] = String(page);
    queryParams["pagination[pageSize]"] = String(pageSize);
  }

  const query = qs.stringify(queryParams, {
    encodeValuesOnly: true,
  });


  try {
    const response = await uninterceptedAxiosInstance.get(
      backend_url + `vendors?${query}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response.data.data;

    let dataObj = {
      response: the_response,
      status: response.status,
      pagination: response.data.meta.pagination,
    };

    return dataObj;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
  }
};
